import { selectAuthenticatedUser, selectLiveServicesStatus, useSelector } from '@missionlabs/api'
import { useEffect } from 'react'
import { ElectronNotification } from 'shared/utils/notifications/electronNotifications'

import { useNotificationRefs } from './useNotificationRefs'

export const useAuthNotificationListener = (isEnabled: boolean = true) => {
    const { add } = useNotificationRefs()

    const liveServicesConnection = useSelector(selectLiveServicesStatus)
    const user = useSelector(selectAuthenticatedUser)

    useEffect(() => {
        if (!isEnabled || !user || liveServicesConnection !== 'FAILED') return

        // Electron API notification
        const handle = ElectronNotification.create('/notification/auth/logout', user)
        add(user.userID, async () => {
            const id = await handle
            if (!id) return

            ElectronNotification.action(id, 'dismiss', user)
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEnabled, liveServicesConnection])
}
